import type { InternalTreeMapNode } from '../types/internal.js';

export const getNodesForTooltip = (clusterNodes: InternalTreeMapNode[]) => {
  const nodes: InternalTreeMapNode[] = [];

  clusterNodes.forEach((node) => {
    nodes.push(node); // for cluster tooltip
    node.children?.forEach((leaf) => {
      nodes.push(leaf); // for leaf tooltip
    });
  });
  return nodes;
};

/*
  These nodes will be available through the seriesActions callback,
  so only the original properties('name' & 'value') and the 'id' are exposed.
*/
export const getSeriesActionsNodes = (nodes: InternalTreeMapNode[]) => {
  return nodes.map((node) => ({
    id: node.id,
    name: node.name,
    value: node.value,
  }));
};
